import { camelKeyed } from './params_helpers'

const googleConfig = () => camelKeyed(window.GOOGLE_CONFIG)

const googleDriveConfig = () => {
  const { developerKey, clientId, appId } = googleConfig()

  return { developerKey, clientId, appId }
}

const googleDriveConfigured = () => {
  const { developerKey, clientId, appId } = googleDriveConfig()

  return developerKey && clientId && appId
}

const googleMapsConfig = () => {
  const { apiKey } = googleConfig()

  return { apiKey }
}

const googleMapsConfigured = () => {
  const { apiKey } = googleMapsConfig()

  return !!apiKey
}

export {
  googleDriveConfig,
  googleDriveConfigured,
  googleMapsConfig,
  googleMapsConfigured
}
